/* eslint-disable */
const getters = {
  getSize(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
